import i18next from 'i18next'
import React, { useRef, useCallback, useState, forwardRef, useEffect } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { walk } from 'react-sortable-tree'
import { globalOnDemandVars } from '../../../helper/context'
import { getNodeKey } from '../../list/window1/functions'
import * as shortid from 'shortid'
import { produce } from 'immer'
import { cloneDeep, uniqueId } from 'lodash'
import SelectPartOfTree from '../../commonInterface/selectPartOfTree'
import { Button, FileInput, HTMLTable, InputGroup, Menu, MenuDivider, Switch, Tag } from '@blueprintjs/core'
// import { saveAs } from 'file-saver'
import FileSaver from 'file-saver'
import { getParentKey } from '../../../logic/functions'
import { showToastByMenuDirection, truncateDefault } from '../../../helper/functions'
import { Spreadsheet } from '../../list/spreadsheet/classes'
import { createSpreadsheet } from '../../../backend/spreadsheet/createData'
import { DragSource } from 'react-dnd'
import { getInitialRecordProperty } from '../../../logic/SM2+'
import importMediaItem from '../../../backend/mediaItems/importData'
import DragDropContextHOC from '../../../helper/DragDropContext'
import { createUploadType2 } from '../../../backend/uploadType2/createData'
import { Type2Or3Item } from '../../list/uploadType2/class'
import { useTranslation } from 'react-i18next'
import { Type1Item } from './parts/type1Class'

const regexForMediaBlock = /!\[(.*?)]\((.*?)\)/g

// const convertMediaIdString = (prevIdString) => {
//   const nextIdBack = mediaIdDict[prevIdString]
//
//   regexForMediaBlock.lastIndex = 0
//   const regexResult = regexForMediaBlock.exec(prevIdString)
//
//   const idFront = regexResult[1]
//
//   return `[${idFront}](${nextIdBack})`
// }

const getMediaId = (type, backId) => (
  type + backId
)
const getMediaIdString = (type, backId) => (
  `![${type}](${backId})`
)
const mediaIdStringToId = (idString) => {
  regexForMediaBlock.lastIndex = 0
  const regexResult = regexForMediaBlock.exec(idString)
  return getMediaId(regexResult[1], regexResult[2])
}

// -----------------------------------------------------------------------------------------------------------

const gatherMediasFromOneString = (string, mediaSet) => {
  regexForMediaBlock.lastIndex = 0
  if (regexForMediaBlock.test(string)) {
    regexForMediaBlock.lastIndex = 0

    let oneMedia = regexForMediaBlock.exec(string)
    while (oneMedia) {
      const mediaId = getMediaId(oneMedia[1], oneMedia[2])
      if (globalOnDemandVars.type1Items().some((maybeThis) => (String(maybeThis.id) === String(mediaId)))) {
        mediaSet.add(oneMedia[0])
        // if (!mediaIdDict[oneMedia[0]]) {
        //   mediaIdDict[oneMedia[0]] = shortid.generate()
        // }
      }
      oneMedia = regexForMediaBlock.exec(string)
    }
  }
}

const extractMediaAndSpreadsheetAndUploadType2FromNode = (node, mediaSet, spreadsheetSet, uploadType2Set) => {
  walk({
    treeData: [node],
    ignoreCollapsed: false,
    getNodeKey: getNodeKey,
    callback: ({
      node, parentNode, path, lowerSiblingCounts, treeIndex
    }) => {
      if (node.isSpreadsheet) {
        const spreadsheet = globalOnDemandVars.spreadsheets()[node.spreadsheetId]
        if (spreadsheet) {
          spreadsheetSet.add(node.spreadsheetId)

          const rows = spreadsheet.rows
          for (const row of rows) {
            for (const rowMemberKey of Object.keys(row)) {
              const rowMember = row[rowMemberKey]
              if (typeof rowMember === 'string') {
                gatherMediasFromOneString(rowMember, mediaSet)
              }
            }
          }
        }
      }
      if (node.isUploadType2) {
        const uploadType2 = globalOnDemandVars.uploadType2s()[node.uploadType2Id]
        if (uploadType2) {
          uploadType2Set.add(node.uploadType2Id)
        }
      }

      gatherMediasFromOneString(node.title, mediaSet)
      gatherMediasFromOneString(node.subtitle, mediaSet)
    }
  })

  return {
    node, mediaSet, spreadsheetSet, uploadType2Set
  }
}

const mediaSetToMediaArray = (mediaSet) => {
  const mediaArray = []

  mediaSet.forEach((mediaIdString, i) => {
    const mediaId = mediaIdStringToId(mediaIdString)
    const mediaObject = globalOnDemandVars.type1Items().find((maybeItem) => (String(maybeItem.id) === String(mediaId)))

    // const nextBackId = getNextBackId(mediaObject.type, mediaObject.backId)
    const mediaData = {
      backId: mediaObject.backId,
      id: mediaId,
      title: mediaObject.title,
      type: mediaObject.type,
      content: mediaObject.content,
      inTypeItems: true,
      type1Order: -1,
      inWaitingItemsForType1: mediaObject.inWaitingItemsForType1,
      inUsedItemsForType1: mediaObject.inUsedItemsForType1
    }

    mediaArray.push(mediaData)
  })

  mediaArray.reverse()

  return mediaArray
}

const spreadsheetSetToSpreadsheetArray = (spreadsheetSet) => {
  const spreadsheetArray = []

  spreadsheetSet.forEach((spreadsheetId) => {
    const spreadsheetObject = globalOnDemandVars.spreadsheets()[spreadsheetId]

    // const newId = shortid.generate()
    // spreadsheetIdDict[spreadsheetId] = newId
    const spreadsheetData = {
      // id: newId,
      id: spreadsheetId,
      // rows: generateEditedRows(spreadsheetObject.rows),
      rows: spreadsheetObject.rows,
      columns: spreadsheetObject.columns,
      selectedItems1: spreadsheetObject.selectedItems1,
      selectedItems2: spreadsheetObject.selectedItems2,
      configForItems1: spreadsheetObject.configForItems1,
      configForItems2: spreadsheetObject.configForItems2,
      switchForMultipleCard: spreadsheetObject.switchForMultipleCard
    }

    spreadsheetArray.push(spreadsheetData)
  })

  return spreadsheetArray
}

const uploadType2SetToUploadType2Array = (uploadType2Set) => {
  const uploadType2Array = []

  uploadType2Set.forEach((uploadType2Id) => {
    const uploadType2Object = globalOnDemandVars.uploadType2s()[uploadType2Id]

    // const newId = shortid.generate()
    const uploadType2Data = {
      // id: newId,
      id: uploadType2Id,
      type: uploadType2Object.type,
      title: uploadType2Object.title,
      content: uploadType2Object.content,
      fragmentList: uploadType2Object.fragmentList,
      switchForMultipleCard: uploadType2Object.switchForMultipleCard,
      inWaitingList: uploadType2Object.inWaitingList,
      timeStamp: uploadType2Object.timeStamp
    }

    uploadType2Array.push(uploadType2Data)
  })

  return uploadType2Array
}

const getExportObjectFromNode = (node) => {
  const mediaSet = new Set()
  const spreadsheetSet = new Set()
  const uploadType2Set = new Set()

  extractMediaAndSpreadsheetAndUploadType2FromNode(node, mediaSet, spreadsheetSet, uploadType2Set)

  const mediaArray = mediaSetToMediaArray(mediaSet)
  const spreadsheetArray = spreadsheetSetToSpreadsheetArray(spreadsheetSet)
  const uploadType2Array = uploadType2SetToUploadType2Array(uploadType2Set)
  // const editedNode = generateEditedNode(node)

  return {
    mediaArray, spreadsheetArray, uploadType2Array, node
  }
}

export const getJSONFromNodes = (nodeDataArray) => {
  return JSON.stringify(nodeDataArray.map((nodeData) => (getExportObjectFromNode(nodeData.node))))
}
// -----------------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------------------------------

// key: prevIdString, value: nextBackId
const mediaIdDict = {}

const getNextBackId = (type, prevBackId) => {
  const prevIdString = getMediaIdString(type, prevBackId)
  return mediaIdDict[prevIdString]
}
const getNextMediaIdString = (type, prevBackId) => {
  const nextBackId = getNextBackId(type, prevBackId)
  return getMediaIdString(type, nextBackId)
}

const spreadsheetIdDict = {}
const uploadType2IdDict = {}

const generateEditedRows = (prevRows, resetRecord) => {
  return produce(prevRows, draft => {
    for (const row of draft) {
      if (resetRecord) {
        const newRecord = getInitialRecordProperty()
        row.configForRow.difficulty = newRecord.difficulty
        row.configForRow.update = newRecord.update
        row.configForRow.interval = newRecord.interval
        row.configForRow.ratingRecord = newRecord.ratingRecord
      }

      for (const rowMemberKey of Object.keys(row)) {
        const rowMember = row[rowMemberKey]
        if (typeof rowMember === 'string') {
          row[rowMemberKey] = rowMember.replace(regexForMediaBlock, (matched, type, id) => {
            return getNextMediaIdString(type, id)
          })
        }
      }
    }
  })
}

const generateEditedFragments = (prevFragments, resetRecord) => {
  let nextFragments = prevFragments
  if (resetRecord) {
    nextFragments = produce(prevFragments, draft => {
      for (const fragment of draft) {
        const newRecord = getInitialRecordProperty()
        fragment.learningRecord = newRecord
      }
    })
  }
  return nextFragments
}

const generateEditedNode = (node, resetRecord) => {
  const idDict = {}

  const result = cloneDeep(node)

  result.isImportedNode = true
  result.isNewOne = { boolean2: true }

  walk({
    treeData: [result],
    ignoreCollapsed: false,
    getNodeKey,
    callback: ({ node, parentNode, path, lowerSiblingCounts, treeIndex }) => {
      const newId = shortid.generate()
      idDict[node.id] = newId
      node.id = newId

      node.title = node.title.replace(regexForMediaBlock, (matched, type, id) => {
        return getNextMediaIdString(type, id)
      })
      node.subtitle = node.subtitle.replace(regexForMediaBlock, (matched, type, id) => {
        return getNextMediaIdString(type, id)
      })

      if (node.spreadsheetId) {
        node.spreadsheetId = spreadsheetIdDict[node.spreadsheetId]
      }
      if (node.uploadType2Id) {
        node.uploadType2Id = uploadType2IdDict[node.uploadType2Id]
      }

      if (resetRecord) {
        const newRecord = getInitialRecordProperty()
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'import / difficulty of undefined',
            value: {
              editableValues: node.editableValues,
              newRecord
            }
            // , important: true
          })
        }
        node.editableValues.difficulty = newRecord.difficulty
        node.editableValues.update = newRecord.update
        node.editableValues.interval = newRecord.interval
        node.editableValues.ratingRecord = newRecord.ratingRecord
      }
      if (parentNode) {
        const newParentId = idDict[getParentKey(node)]

        node.parentId = newParentId
        node.editableValues.parentId = newParentId
      }
    }
  })

  // walk({
  //   treeData: result.children || [],
  //   ignoreCollapse: false,
  //   getNodeKey,
  //   callback: ({ node, parentNode, path, lowerSiblingCounts, treeIndex }) => {
  //     const newParentId = idDict[getParentKey(node)]
  //
  //     node.parentId = newParentId
  //     node.editableValues.parentId = newParentId
  //
  //   }
  // })

  return result
}

const importedMediaIds = new Set()
const importedSpreadsheetIds = new Set()
const importedUploadType2Ids = new Set()

const externalNodeType = 'toSortableTree'
const externalNodeSpec = {
  beginDrag: (componentProps) => ({
    node: { ...componentProps.node },
    parentNode: null,
    path: [],
    rootPath: { length: -1 },
    treeIndex: 0,
    treeId: uniqueId()
  }),
  endDrag: (props, monitor) => {
    if (monitor.didDrop()) {
      // TODO 우선 여기서 이것들이 잘 할당되는지부터 봐야함
      const { node, mediaArray, spreadsheetArray, uploadType2Array, index } = props

      // TODO 로컬, 글로벌, DB에 집어넣기

      //  spreadsheet
      for (const spreadsheetData of spreadsheetArray) {
        if (!importedSpreadsheetIds.has(spreadsheetData.id)) {
          const newSpreadsheet = new Spreadsheet(spreadsheetData.id, spreadsheetData)
          globalOnDemandVars.spreadsheets()[spreadsheetData.id] = newSpreadsheet
          if (!globalOnDemandVars.isPixelMode()) {
            createSpreadsheet(spreadsheetData.id, spreadsheetData)
            importedSpreadsheetIds.add(spreadsheetData.id)
          }
        }
      }

      for (const uploadType2Data of uploadType2Array) {
        if (!importedUploadType2Ids.has(uploadType2Data.id)) {
          const newUploadType2 = new Type2Or3Item(uploadType2Data)
          globalOnDemandVars.uploadType2s()[uploadType2Data.id] = newUploadType2
          if (!globalOnDemandVars.isPixelMode()) {
            createUploadType2(uploadType2Data.id, uploadType2Data)
            importedUploadType2Ids.add(uploadType2Data.id)
          }
        }
      }

      // media
      const mediaObjectArray = []
      for (const mediaData of mediaArray) {
        if (!importedMediaIds.has(mediaData.id)) {
          const mediaObject = new Type1Item(mediaData.type, mediaData.title, mediaData.content, mediaData.id, mediaData.backId, shortid.generate(), mediaData.inWaitingItemsForType1, mediaData.inUsedItemsForType1)
          mediaObjectArray.push(mediaObject)
          importedMediaIds.add(mediaData.id)
        }
      }
      globalOnDemandVars.set_type1Items(globalOnDemandVars.type1Items().concat(mediaObjectArray))
      const mediaObjectArrayForWaiting = mediaObjectArray.filter((mediaObject) => (mediaObject.inWaitingItemsForType1))
      globalOnDemandVars.set_waitingItemsForType1(mediaObjectArrayForWaiting.concat(globalOnDemandVars.waitingItemsForType1()))
      const mediaObjectArrayForUsed = mediaObjectArray.filter((mediaObject) => (mediaObject.inUsedItemsForType1))
      globalOnDemandVars.set_usedItemsForType1(mediaObjectArrayForUsed.concat(globalOnDemandVars.usedItemsForType1()))

      for (const mediaData of mediaArray) {
        importMediaItem(mediaData)
      }

      const newDraggableNodes = produce(outerDraggableNodes, draft => {
        draft.splice(index, 1)
      })
      outerSetDraggableNodes(newDraggableNodes)
      globalOnDemandVars.set_importedNodes(newDraggableNodes)
    }
  }

  // for (const spreadsheetData of spreadsheetUnion) {
  //   if (!spreadsheetIdDict[spreadsheetData.id]) {
  //     spreadsheetIdDict[spreadsheetData.id] = shortid.generate()
  //   }
  //   spreadsheetData.id = spreadsheetIdDict[spreadsheetData.id]
  //
  //   spreadsheetData.rows = generateEditedRows(spreadsheetData.rows)
  // }
}

const externalNodeCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
  // didDrop: monitor.didDrop()
})

class InnerExternalNodeBaseComponent extends React.Component {
  render () {
    const { connectDragSource, node } = this.props
    return connectDragSource(
      <div>
        <Tag icon='dot' interactive minimal large css={css`cursor: grab !important;`}>
          {truncateDefault(node.title)}
        </Tag>
      </div>, { dragEffect: 'copy' }
    )
  }
}

const ExternalNodeBaseComponent = DragSource(
  externalNodeType, externalNodeSpec, externalNodeCollect
)(InnerExternalNodeBaseComponent)

const generatingDraggableNode = (nodeData, i) => {
  return <ExternalNodeBaseComponent key={nodeData.node.id} index={i} node={nodeData.node} mediaArray={nodeData.mediaArray} spreadsheetArray={nodeData.spreadsheetArray} uploadType2Array={nodeData.uploadType2Array} />
}

// -----------------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------------------------------

let outerDraggableNodes = []
let outerSetDraggableNodes = () => {}
function InnerDataAddOn ({ onlyExport }) {
  const selectPartOfTreeRef = useRef(null)

  const [draggableNodes, setDraggableNodes] = useState(globalOnDemandVars.importedNodes())
  useEffect(() => {
    outerSetDraggableNodes = setDraggableNodes
  }, [])
  useEffect(() => {
    outerDraggableNodes = draggableNodes
  }, [draggableNodes])

  const [resetRecord, setResetRecord] = useState(true)

  const onload = useCallback(
    (e) => {
      try {
        const JSONObject = JSON.parse(e.target.result)

        const mediaArrayArray = JSONObject.map((nodeData) => (nodeData.mediaArray))
        const spreadsheetArrayArray = JSONObject.map((nodeData) => (nodeData.spreadsheetArray))
        const uploadType2ArrayArray = JSONObject.map((nodeData) => (nodeData.uploadType2Array))
        const nodeArray = JSONObject.map((nodeData) => (nodeData.node))

        // modify ids
        for (const mediaArray of mediaArrayArray) {
          for (const mediaData of mediaArray) {
            if (!mediaIdDict[getMediaIdString(mediaData.type, mediaData.backId)]) {
              mediaIdDict[getMediaIdString(mediaData.type, mediaData.backId)] = shortid.generate()
            }
            const newBackId = getNextBackId(mediaData.type, mediaData.backId)
            const newId = getMediaId(mediaData.type, newBackId)

            mediaData.backId = newBackId
            mediaData.id = newId
          }
        }

        for (const spreadsheetArray of spreadsheetArrayArray) {
          for (const spreadsheetData of spreadsheetArray) {
            if (!spreadsheetIdDict[spreadsheetData.id]) {
              spreadsheetIdDict[spreadsheetData.id] = shortid.generate()
            }
            spreadsheetData.id = spreadsheetIdDict[spreadsheetData.id]
            // TODO 밑에줄 lodash 에서 memoization 같은거 쓰면 좋을듯
            spreadsheetData.rows = generateEditedRows(spreadsheetData.rows, resetRecord)
          }
        }

        for (const uploadType2Array of uploadType2ArrayArray) {
          for (const uploadType2Data of uploadType2Array) {
            if (!uploadType2IdDict[uploadType2Data.id]) {
              uploadType2IdDict[uploadType2Data.id] = shortid.generate()
            }
            uploadType2Data.id = uploadType2IdDict[uploadType2Data.id]
            // TODO 밑에줄 lodash 에서 memoization 같은거 쓰면 좋을듯
            uploadType2Data.fragmentList = generateEditedFragments(uploadType2Data.fragmentList, resetRecord)
          }
        }

        const newNodeArray = nodeArray.map((node) => (generateEditedNode(node, resetRecord)))

        // -----------------------------------------------------------------------------------------------------------

        const newDataArray = []
        for (let i = 0; i < JSONObject.length; i++) {
          newDataArray[i] = {
            node: newNodeArray[i],
            mediaArray: mediaArrayArray[i],
            spreadsheetArray: spreadsheetArrayArray[i],
            uploadType2Array: uploadType2ArrayArray[i]
          }
        }

        const concat = newDataArray.concat(draggableNodes)
        setDraggableNodes(concat)
        globalOnDemandVars.set_importedNodes(concat)
      } catch (e) {
        showToastByMenuDirection({
          intent: 'waring',
          message: i18next.t('Something went wrong. Maybe the file is invalid.')
        })
        throw (new Error('import 에러'))
      }
    },
    [resetRecord, draggableNodes]
  )

  const onInputChange = useCallback(
    (e) => {
      const reader = new FileReader()
      reader.onload = onload
      reader.readAsText(e.target.files[0])
    },
    [onload]
  )

  const { t } = useTranslation()

  return (
    <Menu css={css`padding: 10px; overflow-x: hidden;
& > * {
  margin: 5px 0 5px 0;
}
`}>
      {onlyExport ? null : (
        <>
          <div css={css`text-align: center; font-weight: bold;`}>{t('Import')}</div>
          <FileInput css={css`
//& > input { width: 100%; }
& > .bp3-file-upload-input {
    border-radius: 30px;
    box-sizing: border-box;
    padding-left: 10px;
    font-size: 12px;
}
& > .bp3-file-upload-input::after {
  box-shadow: none;
  background: transparent;
  content: '';
}
`} fill onInputChange={onInputChange} />
          <div css={css`padding-left: 10px;`}>
            <span>{t('Reset Learning Records')}</span>
            <Switch checked={resetRecord} inline alignIndicator={'right'} css={css`margin-bottom: -3px;`} onChange={(e) => {
              setResetRecord(e.target.checked)
            }}
            /></div>
          <HTMLTable
            striped css={css` margin: 5px 0;
& td, th {
  padding: 2px !important;
}
`}
          >
            {draggableNodes.map((nodeData, i) => (<tr key={nodeData.node.id}><td>{generatingDraggableNode(nodeData, i)}</td></tr>))}
          </HTMLTable>
          <Button fill minimal text={t('Import as a New File')} css={css`justify-content: start;`} />
          <MenuDivider />
        </>
      )}
      <div css={css`text-align: center; font-weight: bold; margin: 14px 0 8px 0;`}>Export</div>
      <SelectPartOfTree ref={selectPartOfTreeRef} popoverHeight={100} lazyData />
      <Button fill minimal css={css`justify-content: start;`}
        text={t('Export as a Local File')} onClick={() => {
          const nodeDataArray = selectPartOfTreeRef.current.getSelectedNodeData()
          const blob = new Blob([getJSONFromNodes(nodeDataArray)], { type: 'application/json' })
          FileSaver.saveAs(blob, 'LearnObit_Export.json')
          selectPartOfTreeRef.current.clearSelectedNodeData()
        }}
      />
      {onlyExport ? null : <Button fill minimal text={t('Export as an Anki deck')} css={css`justify-content: start;`} />}
    </Menu>
  )
}

// eslint-disable-next-line no-func-assign
InnerDataAddOn = forwardRef(InnerDataAddOn)

const DataAddOn = DragDropContextHOC(InnerDataAddOn)

const DataAddOnBoxClass = new BoxClass(DataAddOn, 'Data', null, 3, { order: 5 })

export default DataAddOnBoxClass

export { DataAddOn }
